var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "my-16"
  }, [_c('v-container', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_vm.section.imageSrc && _vm.section.leftImage !== undefined ? _c('v-col', {
    staticClass: "text-center order-1",
    class: {
      'order-sm-0': _vm.section.leftImage === true,
      'order-sm-1': _vm.section.leftImage === false
    },
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-center align-center full-parent"
  }, [_c('vue-aos', {
    class: {
      animate__zoomInLeft: _vm.section.leftImage === true,
      animate__zoomInRight: _vm.section.leftImage === false
    },
    attrs: {
      "animation-class": "animate__animated"
    }
  }, [_c('v-img', {
    attrs: {
      "contain": "",
      "max-height": "300",
      "src": _vm.section.imageSrc
    }
  })], 1)], 1)]) : _vm._e(), _c('v-col', {
    staticClass: "pa-8 grey--text text--darken-1 order-0",
    class: [{
      'order-sm-1': _vm.section.leftImage === true,
      'order-sm-0': _vm.section.leftImage === false
    }, {
      'd-flex justify-center align-center text-center': !_vm.section.imageSrc || _vm.section.leftImage === undefined
    }],
    attrs: {
      "cols": "12",
      "sm": _vm.section.imageSrc && _vm.section.leftImage !== undefined ? 6 : 12
    }
  }, [_c('div', {
    staticClass: "d-flex justify-center align-md-start align-center"
  }, [_c('div', [_c('vue-aos', {
    class: {
      animate__zoomInRight: _vm.section.leftImage === true,
      animate__zoomInLeft: _vm.section.leftImage === false
    },
    attrs: {
      "animation-class": "animate__animated"
    }
  }, [_c('h2', {
    staticClass: "text-h4 mb-8 black--text",
    domProps: {
      "textContent": _vm._s(_vm.section.title)
    }
  })]), _c('div', {
    class: {
      animate__zoomInRight: _vm.section.leftImage === true,
      animate__zoomInLeft: _vm.section.leftImage === false
    },
    attrs: {
      "animation-class": "animate__animated"
    }
  }, [_c('div', {
    staticStyle: {
      "word-break": "break-word",
      "white-space": "normal"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$sanitize(_vm.section.content))
    }
  })])], 1)])])], 1), _vm.section.buttons && _vm.section.buttons.length ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-center flex-wrap"
  }, _vm._l(_vm.section.buttons, function (btn, i) {
    return _c('v-btn', {
      key: i,
      staticClass: "mx-2 my-1",
      attrs: {
        "href": btn.link,
        "target": "_blank",
        "color": "primary",
        "rounded": "",
        "depressed": ""
      }
    }, [_vm._v(" " + _vm._s(btn.text) + " ")]);
  }), 1)]) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }